import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const RiskLevel = styled.div`
    ${({ riskLevel, theme: { color } }) => css`
        background-color: ${color.riskLevels[riskLevel]};
    `};
    border-radius: 2px;
    height: 20px;
    width: 44px;

    display: flex;
    align-items: center;
    justify-content: center;

    line-height: 13px;
    font-size: 13px;
    font-weight: bold;
    color: #000000;
    margin: 1px;
`;
